<template>
  <div class="container">
    <van-image class="title" :src="require('@/assets/chengnuoshu.png')" />
    <div class="content" v-html="datas.commitment">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  data () {
    return {
      datas: JSON.parse(sessionStorage.getItem('Notice'))
    }
  },
  mounted () {
    console.log(this.datas.commitment)
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0 12px;
  min-height: 100vh;
  background-color: #F7EEE8;
  overflow: hidden;
  .title {
    width: 252px;
    display: block;
    margin: 20px auto;
  }
  .content {
    font-size: 14px;
    line-height: 1.8;
    ol {
      list-style: decimal inside;
    }
  }
}
</style>
